module.exports = __webpack_public_path__ + "img/subjective_evaluation_GUI.20243a86.png";